import { createSelector } from 'reselect';

const rootSelector = (state) => state.overview;

export const isLoadingSelector = createSelector(
  rootSelector,
  ({ isLoading }) => isLoading,
);
